// App.js
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import AlloysCatalog from './pages/AlloysCatalog/AlloysCatalog'; 
import ProductsCatalog from './pages/ProductsCatalog/ProductsCatalog';
import AlloyDetail from './pages/AlloyDetail/AlloyDetail';
import ProductsOverview from './pages/ProductsOverview/ProductsOverview';
import WirePage from './pages/WirePage/WirePage';
import TapePage from './pages/TapePage/TapePage';
import RodPage from './pages/RodPage/RodPage';
import Home from './pages/Home/Home';
import Application from './pages/Application/Application';
import Contacts from './pages/Contacts/Contacts';
import './App.css'
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

function App() {
  useEffect(() => {
    document.documentElement.style.overflowY = 'scroll';
    return () => {
      document.documentElement.style.overflowY = '';
    };
  }, []);
  
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app-wrapper">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            
            <Route path="/produktsiya" element={<ProductsCatalog />}>
              <Route index element={<ProductsOverview />} />
              <Route path="wire" element={<WirePage />} />
              <Route path="tape" element={<TapePage />} />
              <Route path="rod" element={<RodPage />} />
            </Route>
            
            <Route path="/splavi" element={<AlloysCatalog />} />
            <Route path="/splavi/:categoryId" element={<AlloysCatalog />} />
            <Route path="/splavi/:categoryId/:alloyId" element={<AlloyDetail />} />
            
            <Route path="/application" element={<Application />} />
            <Route path="/contacts" element={<Contacts />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;